import React, { FC, useContext } from 'react';
// import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import { Link } from 'react-router-dom';
import UserFragment from './UserFragment';
import { FiSearch } from 'react-icons/fi';
// import { FaUserCircle } from 'react-icons/fa';
import NavbarDropDown from './NavbarDropDown';
import SideBar from './SideBar';
import { IoMdClose } from 'react-icons/io';
import logo from 'app/assets/logo/Website_Logo.svg';
import SearchBar from 'app/components/SearchBar';
import { GiHamburgerMenu } from 'react-icons/gi';
import { NavigationContext } from 'app/contexts/NavigationContext';
import { SearchContext } from 'app/contexts/SearchContext';
// import { WSUserContext } from 'app/contexts/UserContext/UserContext';

import './Navbar.scss';

const Navbar: FC = () => {
  // const user = useContext(WSUserContext);
  const { isSideBar, closeSideBar, showSideBar } =
    useContext(NavigationContext);
  const { menuItems, showSearchBar } = useContext(SearchContext);
  // const { lg } = useBreakpoint();

  return (
    <>
      <SearchBar />
      <header className={'navbar'}>
        <div className={'navbar__left'}>
          <Link to="/">
            <img src={logo} alt="logo" className={'navbar__logo'} />
          </Link>
        </div>
        <NavbarDropDown menuItems={menuItems} />
        <div className={'navbar__right'}>
          <div className={'navbar-icon-container'}>
            {/* {!lg && user.isAuthenticated() ? (
              <Link to="/dashboard">
                <FaUserCircle className={'user-icon-mobile'} />
              </Link>
            ) : (
              <></>
            )} */}
            <FiSearch className={'navbar-icon'} onClick={showSearchBar} />
          </div>
          <div className={'navbar-line'} />
          <UserFragment />
          <SideBar menuItems={menuItems} />
        </div>
        <div className={'navbar-icon-container navbar-icon-hammburger'}>
          {isSideBar ? (
            <IoMdClose
              className={'navbar-icon__close'}
              onClick={closeSideBar}
            />
          ) : (
            <GiHamburgerMenu className={'navbar-icon'} onClick={showSideBar} />
          )}
        </div>
      </header>
    </>
  );
};

export default Navbar;
